import { gql, useQuery } from '@apollo/client'
import React from 'react'
import { getConfiguration } from '../apollo/server'

const GETCONFIGURATION = gql`
  ${getConfiguration}
`

const ConfigurationContext = React.createContext({})

export const ConfigurationProvider = props => {
  const { loading, data, error } = useQuery(GETCONFIGURATION)
  const configuration =
    loading || error || !data.configuration
      ? { currency: '', currencySymbol: '', deliveryRate: 0 }
      : data.configuration

  console.log('Configuration loading:', loading)
  console.log('Configuration error:', error)
  console.log('Configuration data:', data)
  console.log('Final configuration:', configuration)

  return (
    <ConfigurationContext.Provider value={configuration}>
      {props.children}
    </ConfigurationContext.Provider>
  )
}
export const ConfigurationConsumer = ConfigurationContext.Consumer
export default ConfigurationContext
